<template>
  <div
    ref="select"
    class="select-template"
    :class="{'select-template_simple': simple}"
  >
    <div
      class="select-template__btn"
      :class="{'select-template__btn_popup-open': popupOpen, 'select-template__btn_checked' :btnIsChecked}"
      @click="onBtnClick"
    >
      {{ btnText }}
      <i
        v-if="!btnIsChecked"
        class="icon icon-arrow-down icon_tiny select-template__icon-arrow"
        :class="{'select-template__icon-arrow_transform': popupOpen }"
      />
      <i
        v-else
        class="icon icon-remove icon_small select-template__icon-close"
        :class="{'select-template__icon-arrow_transform': popupOpen }"
        @click="onIconCloseClick"
      />
    </div>
    <transition name="fade">
      <div
        v-if="popupOpen"
        class="select-template__popup"
        :class="{'select-template__popup_simple': simple}"
      >
        <input
          v-if="withSearch"
          v-model="searchPlaceholderValue"
          class="select-template__input"
          type="text"
          aria-label="false"
          :placeholder="searchPlaceholder"
        />
        <ul>
          <li
            v-for="(option, i) in optionFiltered"
            :key="option.label"
            class="select-template__li"
          >
            <div
              v-if="!simple"
              class="checkbox-wrap"
            >
              <input
                :id="option.label"
                v-model="checked"
                class="checkbox"
                type="checkbox"
                :value="option.value"
              />
              <label
                class="select-template__label"
                :for="option.label"
              >
                <span class="text-body-m">
                  {{ option.label }}
                </span>
              </label>
            </div>
            <label
              v-else
              class="select-template__label-simple"
              :class="{'select-template__label-simple_checked': checked === option.value}"
            >
              <input
                v-model="checked"
                style="display: none"
                type="radio"
                :value="option.value"
              />
              <span class="text-body-m">
                {{ option.label }}
              </span>
            </label>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
    export default {
        name: 'SelectTemplate',
        props: {
            simple: {
                default: false,
                type: Boolean,
            },
            title: {
                required: true,
                type: String,
            },
            options: {
                required: true,
                type: Array,
            },
            withSearch: {
                default: false,
                type: Boolean,
            },
            searchPlaceholder: {
                default: '',
                type: String,
            },
            value: {
                type: [String, Array],
                default: '',
            },
        },
        data: () => ({
            popupOpen: false,
            checked: [],
            radioChecked: '',
            searchPlaceholderValue: '',
        }),
        computed: {
            optionFiltered() {
                if (!this.searchPlaceholderValue) return this.options
                return this.options
                    .filter(option => option.label.toLowerCase().indexOf(this.searchPlaceholderValue.toLowerCase()) + 1)
            },
            isChecked() {
                return (Array.isArray(this.checked)) ? this.checked.length : true
            },
            btnIsChecked() {
                return this.isChecked && !this.popupOpen
            },
            btnText() {
                if (!this.btnIsChecked) {
                    return this.title
                }
                if (this.simple) {
                    return this.options.find(item => item.value === this.checked).label
                }
                return `${this.title}: ${this.checked.length}`
            },
        },
        watch: {
            value(val) {
              this.checked = val
            },
            checked(val) {
                this.$emit('input', val)
            },
        },
        beforeMount() {
            window.addEventListener('click', this.onWindowClick)
        },
        beforeDestroy() {
            window.removeEventListener('click', this.onWindowClick)
        },
        methods: {
            onBtnClick() {
                this.popupOpen = !this.popupOpen
            },
            onWindowClick(e) {
                if (this.popupOpen && e.target.closest('.select-template') !== this.$refs.select) {
                    this.popupOpen = false
                }
            },
            onIconCloseClick(e) {
                this.checked = []
                e.stopPropagation()
            },
        },
    }
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

</style>
